
import { createSlice } from '@reduxjs/toolkit';
import {
  FacilitiesFetchAction,
  FacilitiesFetchSuccessAction,
  FacilityState,
} from './facilities.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: FacilityState = {
  loading: false,
  error: undefined,
  data: [],
};

const { actReq, actReject, actResolve } = makeActionCreator<FacilityState>();

export const facilitesSlice = createSlice({
  name: 'facilities',
  initialState,
  reducers: {
    fetchFacilities: actReq<FacilitiesFetchAction['payload']>(),
    fetchFacilitiesSuccess:
      actResolve<FacilitiesFetchSuccessAction['payload']>('data'),
    fetchFacilitiesFailure: actReject<Error>(),
  },
});

export const {
  fetchFacilities,
  fetchFacilitiesSuccess,
  fetchFacilitiesFailure,
} = facilitesSlice.actions;

export const actions = {
  ...facilitesSlice.actions,
};

export const useFacilitiesSlice = createSliceHook(
  facilitesSlice.name,
  actions,
  initialState
);
